import { render, staticRenderFns } from "./PickupServiceModal.vue?vue&type=template&id=1196bd3a&"
import script from "./PickupServiceModal.vue?vue&type=script&lang=js&"
export * from "./PickupServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./PickupServiceModal.vue?vue&type=style&index=0&id=1196bd3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports